module.exports = __webpack_public_path__ + "img/AI_06.174ae68b.jpg";